import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  return useDataValue({
    viewPath: props.viewPath,
    context: 'email',
  })
}
